<template>
  <ul
    class="flex flex-wrap flex-col items-start gap-2 text-xs font-medium list-none"
  >
    <li v-for="(value, key) in items" :key>
      <RedesignAccomCardTag
        v-if="key === 'discount'"
        class="bg-hlt-hover text-hlt-contrast"
      >
        {{ value }}%
      </RedesignAccomCardTag>

      <RedesignAccomCardTag
        v-if="key === 'topRated'"
        class="bg-suc text-suc-contrast uppercase"
      >
        {{ $t(`${trPrefix}toprated`) }}
      </RedesignAccomCardTag>

      <RedesignAccomCardTag
        v-if="key === 'new'"
        class="bg-suc text-suc-contrast uppercase"
      >
        {{ $t(`${trPrefix}new`) }}
      </RedesignAccomCardTag>

      <RedesignAccomCardTag
        v-if="key === 'freeCancellation'"
        class="bg-suc-reduced border border-suc capitalize"
      >
        <WebccIcon name="site/tick" class="text-suc h-4 w-4 mr-1"></WebccIcon>

        {{ $t(`${trPrefixFreeCancellation}short`) }}
      </RedesignAccomCardTag>

      <RedesignAccomCardTag
        v-if="key === 'duration'"
        class="bg-bgr opacity-80 text-xs font-semibold"
      >
        {{ value }}
      </RedesignAccomCardTag>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { pickBy } from 'lodash-es'

const trPrefix = 'www.components.hitbox.Tags.'
const trPrefixFreeCancellation = 'plugins.components.FreeCancellationInfo.'

const props = defineProps<{
  tags: RedesignAccomTags
}>()

const items = computed(() => pickBy(props.tags, Boolean))
</script>
